import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <section className="py-12 bg-cardBg border-y border-warmBrown/10" data-id="element-131">
      <div className="max-w-4xl mx-auto px-4" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-133">
          <div className="w-full md:w-1/2 rounded-xl overflow-hidden shadow-md border-4 border-white rotate-[-2deg]" data-id="element-134">
            <img src="https://cdn.magicpatterns.com/uploads/cM6YSHbWD5HB18iTk3CbfT/Magen_Darm_4f46689c-206a-426f-9344-0505df3c965a.webp" alt="Hunderunde Futtertopping Magen & Darm Verpackung" className="w-full h-auto object-contain" data-id="element-135" />
          </div>

          <div className="w-full md:w-1/2" data-id="element-136">
            <h3 className="font-handwritten text-4xl text-forestGreen mb-4" data-id="element-137">
              Was ich bestellt habe
            </h3>
            <div className="font-serif text-lg text-gray-800 space-y-4" data-id="element-138">
              <p data-id="element-139">
                Ich habe mich für das Magen-Darm-Topping von Hunderunde
                entschieden, weil es zu{' '}
                <strong data-id="element-140">100% aus natürlichen Zutaten</strong> besteht und
                komplett auf künstliche Zusätze verzichtet.
              </p>
              <p data-id="element-141">
                Anstatt Milos Magen mit weiterer Chemie zu belasten, wollte ich
                seine Magenschleimhaut sanft und nachhaltig mit bewährten
                Kräutern wie Mariendistel und Artischocke unterstützen.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}